var _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluebackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 875,
    viewBox: "0 0 1440 875",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nbga0simba)",
    d: "M0 0h1440v811H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.33 32.788C984.732 26.52 917.34 15.284 847.932 8.47c-98.868-9.713-201.828-10.3-300.54-.227-95.928 9.766-195.396 33.584-290.184 45.685C173.148 64.664 81.372 69.085 0 55.671V0h1440v15.889c-122.96 22.571-256.34 28.415-385.67 16.899z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.33 843.788c-69.598-6.268-136.99-17.504-206.398-24.318-98.868-9.713-201.828-10.3-300.54-.227-95.928 9.766-195.396 33.584-290.184 45.685C173.148 875.664 81.372 880.085 0 866.671V811h1440v15.889c-122.96 22.571-256.34 28.416-385.67 16.899z",
    fill: "#9CC8FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "xnmev1698b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 720,
    y: 803,
    width: 720,
    height: 72
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M720 803h720v72H720z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#xnmev1698b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1054.33 843.788c-69.598-6.268-136.99-17.504-206.398-24.318-98.868-9.713-201.828-10.3-300.54-.227-95.928 9.766-195.396 33.584-290.184 45.685C173.148 875.664 81.372 880.085 0 866.671V811h1440v15.889c-122.96 22.571-256.34 28.416-385.67 16.899z",
    fill: "#64A6F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nbga0simba",
    x1: 1440,
    y1: 0,
    x2: 744.794,
    y2: 1281.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0D5FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluebackground);
export default __webpack_public_path__ + "static/media/bluebackground.7701e3a82b8cf1f4c629da46aa558075.svg";
export { ForwardRef as ReactComponent };